import Head from 'next/head';
import React from 'react';
import Meta from '../../components/Meta';

const Tarms = () => {
	return (
		<div>
			<Meta title="Disclaimer" />
			<div className="pt-[5.5rem] lg:pt-24">
				{/* <!-- TOS --> */}
				<section className="dark:bg-jacarta-800 relative py-16 md:py-24">
					<picture className="pointer-events-none absolute inset-0 -z-10 dark:hidden">
						<img src="/images/gradient_light.jpg" alt="gradient" className="h-full w-full" />
					</picture>
					<div className="container">
						<h1 className="font-display text-jacarta-700 text-center text-4xl font-medium dark:text-white">
							Disclaimer
						</h1>
						<div className="article-content mx-auto max-w-[48.125rem]">
							<h2 className="text-base">Otaku Inu</h2>
							<p>
								{
									"Otaku Inu is a meme coin intended for entertainment purposes only. It is important to understand that investing in Otaku Inu carries no financial advice or expectations of future plans, as there is no formal team or roadmap behind it."
								}
							</p>
							<p>
								{
									"However, if you're ready to embrace the excitement and unpredictability of the crypto world, Otaku Inu welcomes you to join the community and embark on an exhilarating journey where surprises await at every turn. Remember to approach this meme coin with a sense of fun and adventure, keeping in mind that financial gains are not guaranteed. Enjoy the thrilling ride with Otaku Inu!"
								}
							</p>
						</div>
					</div>
				</section>
				{/* <!-- end TOS --> */}
			</div>
		</div>
	);
};

export default Tarms;
